import React from "react"
import Layout from "../components/Layout"

export default function About() {
  return (
    <Layout>
      <div>
        <h1>about</h1>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ullam
          delectus aliquid eum quos! Magni, tenetur corporis! Fugit sint,
          blanditiis repellat, perferendis quisquam ad quis nesciunt doloremque
          quae soluta autem maiores!
        </p>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Minus tempore
          mollitia quaerat laborum facere ipsum, corrupti cupiditate aperiam
          autem voluptate quo! Velit praesentium exercitationem sunt provident
          incidunt, nesciunt deleniti odit?
        </p>
      </div>
    </Layout>
  )
}
